'use strict';

module.exports = [
  '$scope',
  '$modal',
  'title',
  'content',
  HelpController];

function HelpController($scope, $modal, title, content) {
  const vm = $scope.helpCtrl = this;

  vm.title = title;
  vm.content = content;

  vm.close = $modal.cancel.bind($modal);
}



// WEBPACK FOOTER //
// ./src/js/core-components/help/HelpController.js